import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="admin-layout">
      {!sidebarOpen && (
        <button 
          className="mobile-menu-toggle"
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          ☰
        </button>
      )}
      {sidebarOpen && (
        <div 
          className="mobile-menu-overlay active"
          onClick={closeSidebar}
        />
      )}
      <Sidebar userRole="admin" isOpen={sidebarOpen} onClose={closeSidebar} />
      <Topbar userRole="admin" />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;

